import React from 'react';
import { connect } from 'react-redux';
import { CurrentSweepstakes, CurrentPromotions, DisplayContent, ErrorBoundary } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import ProgressiveJackpot from '../Components/ProgressiveJackpot/ProgressiveJackpot';
import getConfigForComponent from '../utils/getConfigForComponent';
import promotionConfig from '../promotionConfig';

const Promotions = ({ user, config, sweep, promotion, cmsSourceFirebase, actions, match }) => {
    const promotionsCurrentSweepstakes = getConfigForComponent('promotionsCurrentSweepstakes', config);
    const promotionsCurrentPromotions = getConfigForComponent('promotionsCurrentPromotions', config);

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <DisplayContent
                note='Show Promotions page Current Sweepstakes / Second-Chance Promotions section'
                isVisible={promotionsCurrentSweepstakes?.enabled}>
                <section id={promotionsCurrentSweepstakes?.hash}>
                    <ErrorBoundary fallback={promotionsCurrentSweepstakes?.errorBoundaryFallback} details={{ user, config }}>
                        <CurrentSweepstakes
                            {...{ sweep, cmsSourceFirebase, actions }}
                            telescript={promotionsCurrentSweepstakes?.telescript}
                            mode={promotionsCurrentSweepstakes?.config?.mode ?? 'all-current-promotions'}
                            ProgressiveJackpot={ProgressiveJackpot}
                            options={
                                promotionsCurrentSweepstakes?.config ?? {
                                    hasCollapser: false,
                                    variant: 'theme-primary',
                                }
                            }
                        />
                    </ErrorBoundary>
                </section>
            </DisplayContent>

            <DisplayContent note='Show Promotions page Current Promotions / My Rewards / Achievements section' isVisible={promotionsCurrentPromotions?.enabled}>
                <section id={promotionsCurrentPromotions?.hash}>
                    <ErrorBoundary fallback={promotionsCurrentPromotions?.errorBoundaryFallback} details={{ user, config }}>
                        <CurrentPromotions
                            {...{ user, config, promotion, cmsSourceFirebase, actions }}
                            telescript={promotionsCurrentPromotions?.telescript}
                            mode={promotionsCurrentPromotions?.config?.mode ?? 'show-limited'}
                            options={
                                promotionsCurrentPromotions?.config ?? {
                                    hasCollapser: false,
                                    variant: 'theme-primary',
                                    jurisdiction: promotionConfig?.jurisdiction,
                                }
                            }
                        />
                    </ErrorBoundary>
                </section>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Promotions);
